export const isInitiativeInPlanningGroups = (planningGroups, selectedGroups, initiativeId) => {
    // Check if initiative is in any of the selected planning groups
    for (let i = 0; i < selectedGroups.length; i++) {
        const groupName = selectedGroups[i];
        const groupInitiatives = planningGroups[groupName];

        if (groupInitiatives && groupInitiatives.some(init => init._id === initiativeId)) {
            return true;
        }
    }
    return false;
};

// Even more optimized version using Sets for O(1) lookups
export const isInitiativeInPlanningGroupsOptimized = (planningGroups, selectedGroups, initiativeId) => {
    // Create a Set of initiative IDs from all selected planning groups
    for (let i = 0; i < selectedGroups.length; i++) {
        const groupName = selectedGroups[i];
        const groupInitiatives = planningGroups[groupName];

        if (groupInitiatives) {
            for (let j = 0; j < groupInitiatives.length; j++) {
                if (groupInitiatives[j]._id === initiativeId) {
                    return true;
                }
            }
        }
    }
    return false;
};

// Precompute version for even better performance (if you filter frequently)
export const createPlanningSummaryLookup = (planningGroups) => {
    const lookup = new Map();

    Object.entries(planningGroups).forEach(([groupName, initiatives]) => {
        initiatives.forEach(initiative => {
            if (!lookup.has(initiative._id)) {
                lookup.set(initiative._id, new Set());
            }
            lookup.get(initiative._id).add(groupName);
        });
    });

    return lookup;
};
export const createPlanningSummarySimplifiedLookup = (planningGroups) => {
    const lookup = new Map();
    
    Object.entries(planningGroups).forEach(([groupName, initiatives]) => {
      initiatives.forEach(initiative => {
        if (!lookup.has(initiative._id)) {
          lookup.set(initiative._id, new Set());
        }
        lookup.get(initiative._id).add(groupName);
      });
    });
    
    return lookup;
  };